import http from './http';

// 獲取產品代尋列表
export const getProductRequests = async (params = {}) => {
  try {
    const response = await http.get('/admin/product-requests', { params });
    return response.data;
  } catch (error) {
    console.error('獲取產品代尋列表失敗:', error);
    throw error;
  }
};

// 獲取單個產品代尋詳情
export const getProductRequestById = async (id) => {
  try {
    const response = await http.get(`/admin/product-requests/${id}`);
    return response.data;
  } catch (error) {
    console.error(`獲取產品代尋 ${id} 詳情失敗:`, error);
    throw error;
  }
};

// 添加回覆
export const addReply = async (id, replyData) => {
  try {
    const response = await http.post(`/admin/product-requests/${id}/replies`, replyData);
    return response.data;
  } catch (error) {
    console.error(`添加回覆失敗:`, error);
    throw error;
  }
};

// 新增產品代尋記錄
export const createProductRequest = async (requestData) => {
  try {
    const response = await http.post('/admin/product-requests', requestData);
    return response.data;
  } catch (error) {
    console.error('新增產品代尋記錄失敗:', error);
    throw error;
  }
};

// 刪除產品代尋記錄
export const deleteProductRequest = async (id) => {
  try {
    const response = await http.delete(`/admin/product-requests/${id}`);
    return response.data;
  } catch (error) {
    console.error(`刪除產品代尋記錄 ${id} 失敗:`, error);
    throw error;
  }
};

// 更新產品代尋狀態
export const updateProductRequestStatus = async (id, statusData) => {
  try {
    const response = await http.put(`/admin/product-requests/${id}/status`, statusData);
    return response.data;
  } catch (error) {
    console.error(`更新狀態失敗:`, error);
    throw error;
  }
};

// 獲取統計數據
export const getProductRequestStats = async () => {
  try {
    const response = await http.get('/admin/product-requests/stats/overview');
    return response.data;
  } catch (error) {
    console.error('獲取統計數據失敗:', error);
    throw error;
  }
};

// 獲取未讀留言數量（待處理狀態的留言數量）
export const getUnreadRequestsCount = async () => {
  try {
    const response = await http.get('/admin/product-requests/stats/overview');
    return response.data.pending || 0;
  } catch (error) {
    console.error('獲取未讀留言數量失敗:', error);
    return 0;
  }
};

export default {
  getProductRequests,
  getProductRequestById,
  addReply,
  updateProductRequestStatus,
  getProductRequestStats,
  getUnreadRequestsCount
};
